/* Bright Solar Lights — homepage rework */
(function () {
  var GOLD = "#F5A800";

  function svg(paths) {
    return (
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
      'stroke-linecap="round" stroke-linejoin="round" width="26" height="26">' + paths + "</svg>"
    );
  }
  var ICON = {
    glow: svg('<path d="M12 2.6v2"/><path d="M4.6 5.6 6 7"/><path d="M19.4 5.6 18 7"/><path d="M2.6 13h2"/><path d="M19.4 13h2"/><path d="M8.3 13a3.7 3.7 0 1 1 7.4 0c0 1.5-.9 2.2-1.4 2.8-.4.5-.6.9-.6 1.5h-3.4c0-.6-.2-1-.6-1.5-.5-.6-1.4-1.3-1.4-2.8Z"/><path d="M10.2 20h3.6"/><path d="M10.8 22h2.4"/>'),
    shield: svg('<path d="M12 21.6s7.4-3.7 7.4-9.3V5.5L12 2.6 4.6 5.5v6.8c0 5.6 7.4 9.3 7.4 9.3Z"/><path d="m9.2 12 2 2 3.6-3.8"/>'),
    clock: svg('<circle cx="12" cy="12.4" r="8.3"/><path d="M12 7.7v4.9l3.1 1.9"/>')
  };
  var ICON_FOR = [
    { m: /paths|patios|outdoor living/i, s: ICON.glow },
    { m: /motion|driveway|security/i, s: ICON.shield },
    { m: /fit it yourself|electrician/i, s: ICON.clock }
  ];

  function styles() {
    if (document.getElementById("bsl-tweak-style")) return;
    var s = document.createElement("style");
    s.id = "bsl-tweak-style";
    s.textContent = [
      ".bsl-marquee-white,.bsl-marquee-white *{color:#fff !important;opacity:1 !important}",

      /* tighter rhythm across the whole page */
      "main section, main > div > section{padding-top:4rem !important;padding-bottom:4rem !important}",
      "@media(min-width:640px){main section, main > div > section{padding-top:5rem !important;padding-bottom:5rem !important}}",
      "#range{padding-bottom:3.5rem !important}",
      "#homes{padding-top:0 !important}",
      "#homes > div:first-child,#homes .mx-auto:first-child{padding-top:3rem !important}",

      /* icons: no chip, gold line mark */
      ".bsl-icon-chip{display:inline-flex;align-items:center;justify-content:center;" +
        "width:auto !important;height:auto !important;background:none !important;" +
        "border:0 !important;border-radius:0 !important;color:" + GOLD + ";flex-shrink:0}",
      ".bsl-icon-host{background:none !important;border:0 !important;border-radius:0 !important;" +
        "width:auto !important;height:auto !important;padding:0 !important;box-shadow:none !important}",

      /* product cards breathe */
      "#range [class*='grid']{gap:1.6rem !important}",
      "#range h3{font-size:1.02rem !important;line-height:1.35 !important;overflow-wrap:anywhere}",
      "#range p,#range li,#range span{overflow-wrap:anywhere}",
      "#range a[href='#quote']{white-space:nowrap;display:inline-flex;align-items:center;justify-content:center}",

      /* trust strip in black */
      "#bsl-trust{display:flex !important;flex-wrap:wrap;gap:.55rem .5rem;margin:1.15rem 0 0 !important;" +
        "font-size:.8rem !important;color:#171A15 !important;opacity:1 !important;font-weight:500;white-space:normal !important}",
      "#bsl-trust .bsl-chip{display:inline-flex;align-items:center;gap:.4rem;background:rgba(23,26,21,.05);" +
        "border:1px solid rgba(23,26,21,.14);border-radius:999px;padding:.4rem .75rem;color:#171A15}",
      "#bsl-trust .bsl-chip b{color:" + GOLD + ";font-weight:700}",

      ".bsl-hl{color:" + GOLD + "}",

      /* reviews */
      "#bsl-reviews{padding:4.5rem 1.5rem !important;background:#EEF0EB}",
      ".bsl-rv-inner{max-width:1200px;margin:0 auto}",
      ".bsl-rv-head{display:flex;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;gap:1rem;margin-bottom:2.2rem}",
      ".bsl-rv-label{font-size:.72rem;letter-spacing:.18em;text-transform:uppercase;color:#72746A;font-family:Inter,system-ui,sans-serif;margin:0 0 .6rem}",
      ".bsl-rv-title{font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;font-weight:900;font-size:clamp(1.9rem,4vw,2.9rem);line-height:1;letter-spacing:-.03em;color:#171A15;margin:0}",
      ".bsl-rv-score{display:flex;align-items:center;gap:.7rem;font-family:Inter,system-ui,sans-serif}",
      ".bsl-rv-score .num{font-size:2rem;font-weight:700;color:#171A15;line-height:1}",
      ".bsl-rv-score .meta{font-size:.8rem;color:#72746A;line-height:1.4}",
      ".bsl-rv-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:1.1rem}",
      "@media(max-width:980px){.bsl-rv-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}",
      "@media(max-width:640px){.bsl-rv-grid{grid-template-columns:1fr}}",
      ".bsl-rv-card{background:#fff;border:1px solid rgba(23,26,21,.10);border-radius:14px;padding:1.4rem 1.35rem;display:flex;flex-direction:column;gap:.7rem;min-height:200px}",
      ".bsl-rv-stars{color:" + GOLD + ";font-size:.95rem;letter-spacing:.12em}",
      ".bsl-rv-body{font-family:Inter,system-ui,sans-serif;font-size:.94rem;line-height:1.6;color:#333A31;flex:1;margin:0}",
      ".bsl-rv-h{font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;font-weight:700;font-size:1rem;color:#171A15;margin:0}",
      ".bsl-rv-foot{display:flex;align-items:center;justify-content:space-between;gap:.6rem;border-top:1px solid rgba(23,26,21,.10);padding-top:.75rem;font-family:Inter,system-ui,sans-serif}",
      ".bsl-rv-name{font-size:.85rem;font-weight:600;color:#171A15}",
      ".bsl-rv-prod{font-size:.72rem;color:#72746A;text-align:right;max-width:55%}",
      ".bsl-rv-verified{font-size:.68rem;color:#72746A;display:block;font-weight:400}",

      /* 10% block */
      "#bsl-promo{padding:4.5rem 1.5rem !important;background:#171A15;text-align:center}",
      ".bsl-promo-inner{max-width:600px;margin:0 auto}",
      ".bsl-promo-label{font-size:.72rem;letter-spacing:.18em;text-transform:uppercase;color:" + GOLD + ";font-family:Inter,system-ui,sans-serif;margin:0 0 .9rem}",
      ".bsl-promo-title{font-family:Satoshi,ui-sans-serif,system-ui,sans-serif;font-weight:900;font-size:clamp(2rem,4.5vw,3rem);line-height:1.02;letter-spacing:-.03em;color:#fff;margin:0 0 1.1rem}",
      ".bsl-promo-title span{color:" + GOLD + "}",
      ".bsl-promo-copy{font-family:Inter,system-ui,sans-serif;font-size:.95rem;line-height:1.65;color:rgba(238,240,235,.66);margin:0 0 2rem}",
      ".bsl-promo-form{display:flex;gap:.6rem;background:rgba(255,255,255,.06);border:1px solid rgba(245,168,0,.28);border-radius:12px;padding:.45rem;margin-bottom:1.2rem}",
      ".bsl-promo-form input{flex:1;background:transparent;border:0;outline:none;color:#fff;font-size:.9rem;padding:.6rem .75rem;font-family:Inter,system-ui,sans-serif}",
      ".bsl-promo-form input::placeholder{color:rgba(238,240,235,.45)}",
      ".bsl-promo-form button{background:" + GOLD + ";color:#171A15;border:0;padding:.7rem 1.6rem;border-radius:9px;font-weight:700;font-size:.85rem;cursor:pointer;white-space:nowrap;font-family:Inter,system-ui,sans-serif;transition:background .2s}",
      ".bsl-promo-form button:hover{background:#FFC94D}",
      ".bsl-promo-perks{display:flex;justify-content:center;gap:1.6rem;flex-wrap:wrap}",
      ".bsl-promo-perks span{font-size:.78rem;color:rgba(238,240,235,.6);display:flex;align-items:center;gap:.4rem;font-family:Inter,system-ui,sans-serif}",
      ".bsl-promo-perks span::before{content:'✓';color:" + GOLD + ";font-weight:700}",
      ".bsl-promo-done{color:" + GOLD + ";font-family:Inter,system-ui,sans-serif;font-size:.95rem;margin:.6rem 0 0}",
      "@media(max-width:600px){.bsl-promo-form{flex-direction:column}}"
    ].join("");
    document.head.appendChild(s);
  }

  function litImage() {
    return (
      document.querySelector('img[data-bsl-role="lit"]') ||
      document.querySelector('img[src*="street-lit"]') ||
      document.querySelector('img[src*="084509"]')
    );
  }

  function stats() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      if (/^\s*12,000\+\s*$/.test(n.nodeValue)) n.nodeValue = "Safe & secure";
      else if (/^\s*(Lights installed|Homes and businesses)\s*$/i.test(n.nodeValue)) n.nodeValue = "Every night, all year";
    }
  }

  function marquee() {
    var spans = document.querySelectorAll("span"), span = null;
    for (var i = 0; i < spans.length; i++) {
      if (/^\s*Homeowners\s*$/.test(spans[i].textContent) && !spans[i].children.length) { span = spans[i]; break; }
    }
    if (!span) return;
    var wrap = span.closest(".relative.overflow-hidden") || span.closest("div");
    if (wrap) wrap.classList.add("bsl-marquee-white");
  }

  function heading() {
    var hs = document.querySelectorAll("h2");
    for (var i = 0; i < hs.length; i++) {
      var h = hs[i];
      if (/garden, glowing|garden you can use/i.test(h.textContent) && !h.dataset.bslDone) {
        h.dataset.bslDone = "1";
        h.innerHTML = 'A <span class="bsl-hl">garden</span> you can use. A home that feels <span class="bsl-hl">safe</span>.';
        return;
      }
    }
  }

  function icons() {
    var imgs = document.querySelectorAll(
      'img[src*="icon-moon"],img[src*="icon-radar"],img[src*="icon-wrench"]'
    );
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i], li = img.closest("li") || img.parentElement;
      var label = li ? li.textContent : "", chosen = null;
      for (var j = 0; j < ICON_FOR.length; j++) {
        if (ICON_FOR[j].m.test(label)) { chosen = ICON_FOR[j].s; break; }
      }
      if (!chosen) continue;
      var host = img.parentElement;
      var holder = document.createElement("span");
      holder.className = "bsl-icon-chip";
      holder.innerHTML = chosen;
      img.replaceWith(holder);
      if (host && host !== li) host.classList.add("bsl-icon-host");
    }
    var chips = document.querySelectorAll(".bsl-icon-chip");
    for (var k = 0; k < chips.length; k++) {
      var p = chips[k].parentElement;
      if (p && /bg-night|bg-ink/.test(p.className || "")) p.classList.add("bsl-icon-host");
    }
  }

  function trust() {
    var t = document.getElementById("bsl-trust");
    if (!t || t.dataset.bslStyled) return;
    t.dataset.bslStyled = "1";
    t.innerHTML = ["1 year warranty", "UK-based support", "Ships UK & worldwide", "Fits in 5 minutes"]
      .map(function (p) { return '<span class="bsl-chip"><b>✓</b> ' + p + "</span>"; }).join("");
  }

  function contact() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n, hits = [];
    while ((n = w.nextNode())) {
      if (/soona_232@hotmail\.co\.uk/i.test(n.nodeValue)) hits.push({ n: n, k: "v" });
      else if (/^\s*Email\s*$/i.test(n.nodeValue)) hits.push({ n: n, k: "l" });
    }
    hits.forEach(function (h) {
      h.n.nodeValue = h.k === "l" ? "Care plan" : "Available on all lights";
    });
  }

  function torch() {
    var lit = litImage();
    if (!lit || lit.dataset.bslSnap) return;
    lit.dataset.bslSnap = "1";
    var REST = 90, TRIGGER = 4, EASE = 0.3, current = REST;
    function full() {
      return Math.hypot(window.innerWidth || 1200, window.innerHeight || 800) * 1.2;
    }
    (function tick() {
      var cp = lit.style.clipPath || "";
      if (cp.indexOf("circle(") > -1) {
        var open = (window.scrollY || window.pageYOffset || 0) > TRIGGER;
        var target = open ? full() : REST;
        current += (target - current) * EASE;
        if (Math.abs(target - current) < 1) current = target;
        lit.style.clipPath = cp.replace(/circle\(\s*[\d.]+px/, "circle(" + current.toFixed(0) + "px");
      }
      requestAnimationFrame(tick);
    })();
  }

  function run() {
    styles(); stats(); marquee(); heading(); icons(); trust(); contact(); torch();
  }

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
})();
